
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/context-module-progressions/jst/ProgressionModuleCollection';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function";

function program1(depth0,data) {
  
  
  return "\n    <ul class=\"collectionViewItems\"></ul>\n  ";
  }

function program3(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.atLeastOnePageFetched), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <p class=\"message\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("modules.progression_module_collection")
  },data:data},helper ? helper.call(depth0, "modules.progression_module_collection.no_modules_found", "No modules were found", options) : helperMissing.call(depth0, "t", "modules.progression_module_collection.no_modules_found", "No modules were found", options)))
    + "</p>\n    ";
  return buffer;
  }

  buffer += "<h2 id=\"student_"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.student)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "_header\" class=\"screenreader-only\">\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'student.name': (((stack1 = (depth0 && depth0.student)),stack1 == null || stack1 === false ? stack1 : stack1.name)),
    'i18n_scope': ("modules.progression_module_collection")
  },data:data},helper ? helper.call(depth0, "modules.progression_module_collection.module_progress_for_student", "Module Progress for %{student.name}", options) : helperMissing.call(depth0, "t", "modules.progression_module_collection.module_progress_for_student", "Module Progress for %{student.name}", options)))
    + "\n</h2>\n<h2 class=\"student-header\" aria-hidden=\"true\">\n  ";
  stack1 = (helper = helpers.__i18nliner_escape || (depth0 && depth0.__i18nliner_escape),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.studentUrl), options) : helperMissing.call(depth0, "__i18nliner_escape", (depth0 && depth0.studentUrl), options));
  stack1 = (helper = helpers.__i18nliner_concat || (depth0 && depth0.__i18nliner_concat),options={hash:{},data:data},helper ? helper.call(depth0, "<a href=\"", stack1, "\">$1</a>", options) : helperMissing.call(depth0, "__i18nliner_concat", "<a href=\"", stack1, "\">$1</a>", options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': (stack1),
    'student.name': (((stack1 = (depth0 && depth0.student)),stack1 == null || stack1 === false ? stack1 : stack1.name)),
    'i18n_scope': ("modules.progression_module_collection")
  },data:data},helper ? helper.call(depth0, "modules.progression_module_collection.module_progress_for", "Module Progress for *%{student.name}*", options) : helperMissing.call(depth0, "t", "modules.progression_module_collection.module_progress_for", "Module Progress for *%{student.name}*", options)))
    + "\n</h2>\n<div class=\"module-progressions\">\n  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.length), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  